import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  basePriceARS: number;
  className?: string;
}
export function PriceDisplay({
  basePriceARS,
  className = ''
}: PriceDisplayProps) {
  const [displayPrice, setDisplayPrice] = useState(`$${basePriceARS.toLocaleString('es-AR')} ARS`);
  useEffect(() => {
    try {
      const locale = navigator.language || 'es-AR';
      const lowerLocale = locale.toLowerCase();
      // Approximate conversions for demonstration (in a real app, use live rates)
      const usdRate = 1000; // 1 USD = 1000 ARS approx
      const eurRate = 1100; // 1 EUR = 1100 ARS approx
      const gbpRate = 1250; // 1 GBP = 1250 ARS approx
      if (lowerLocale.includes('ar')) {
        setDisplayPrice(`$${basePriceARS.toLocaleString('es-AR')} ARS`);
      } else if (lowerLocale.includes('gb') || lowerLocale.includes('uk')) {
        const gbp = Math.round(basePriceARS / gbpRate);
        setDisplayPrice(`£${gbp}`);
      } else if (lowerLocale.includes('es-es') || lowerLocale.includes('fr') || lowerLocale.includes('de') || lowerLocale.includes('it')) {
        const eur = Math.round(basePriceARS / eurRate);
        setDisplayPrice(`€${eur}`);
      } else if (lowerLocale.includes('en')) {
        // Default English to USD
        const usd = Math.round(basePriceARS / usdRate);
        setDisplayPrice(`$${usd} USD`);
      } else {
        // Fallback to ARS for other LATAM or unknown
        setDisplayPrice(`$${basePriceARS.toLocaleString('es-AR')} ARS`);
      }
    } catch (e) {
      // Fallback on error
      setDisplayPrice(`$${basePriceARS.toLocaleString('es-AR')} ARS`);
    }
  }, [basePriceARS]);
  return <span className={className} data-id="element-122">{displayPrice}</span>;
}